import { useHistory } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ProfileWrapper, ProfileCircle } from "./styles";

const ProfileMenu = () => {
  const auth = useAuth();
  const history = useHistory();

  const displayName =
    auth.profile?.display_name ||
    auth.profile?.handle ||
    auth.user?.name ||
    auth.user?.email ||
    "";

  const avatarUrl = auth.profile?.avatar_url || null;

  return (
    <ProfileWrapper>
      <ProfileCircle
        type="button"
        onClick={() => history.push("/me")}
        aria-label={displayName || "Profile"}
      >
        <img
          src={avatarUrl || "/explore/avatar/cat_avatar.webp"}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "999px",
            objectFit: "cover",
          }}
        />
      </ProfileCircle>
    </ProfileWrapper>
  );
};

export default ProfileMenu;
